/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import IconButton from '@/components/buttons/IconButton'
import {
  LIST_ASSETS_FOR_BUILDINGS_SAMS,
  REVENUE_BREAKDOWN,
  SET_COVER_IMAGE,
  ASSET_METADATA
} from '@/configs/strings/labels'
import { Button, Flex } from '@chakra-ui/react'
import { useResponsive } from '@/hooks/useResponsive'

const ButtonBar = ({
  openModal,
  onListAssetsClick,
  onRevenueClick,
  showBuildLicense,
  showRevenue,
  activeModal
}) => {
  const { flexDirection, flexGap } = useResponsive()

  return (
    <Flex
      flexDirection={flexDirection}
      gap={flexGap}
      className="mb-5"
    >
      <Button
        className="uppercase"
        onClick={onListAssetsClick}
        bg={showBuildLicense ? '#1C2646' : null}
      >
        {LIST_ASSETS_FOR_BUILDINGS_SAMS}
      </Button>
      <Button
        className="uppercase"
        onClick={onRevenueClick}
        bg={showRevenue ? '#1C2646' : null}
      >
        {REVENUE_BREAKDOWN}
      </Button>
      <IconButton
        icon="FaImage"
        label={SET_COVER_IMAGE}
        onClick={() => openModal('setCover')}
        activeModal={activeModal === 'setCover'}
      />
      <IconButton
        icon="FaRegListAlt"
        label={ASSET_METADATA}
        onClick={() => openModal('metadata')}
        activeModal={activeModal === 'metadata'}
      />
    </Flex>
  )
}

export default ButtonBar
